"use strict";
import "../api/api";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
import Blocker from "./blocker";
import CarrierSetter from "./carrier_setter";
import DocumentBrowser from "./react_document_browser";
import "./indexer/email_viewer";
import EmailHelper from "../helpers/email_message";
import ExceptionSender from "./exception_sender";
import IndexerHeader from "./indexer/indexer_header";
import "./indexer/load_detail_information";
import MarkEmailCompleteView from "./mark_email_complete_view";
import moment from "moment";
import PresenceList from "./presence";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { History } from "react-router";
import { EmailForwarderMixin } from "./email_forwarder";
import { NoDocumentsProgressBar } from "./progress_bars";
var EmailWithoutDocuments = React.createClass({
  mixins: [EmailForwarderMixin, History],
  propTypes: {
    location: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return { step: !this.props.email.document_batch_carrier_id && _.isNull(this.props.email.single_carrier) ? 0 : 1 };
  },
  getStepLabel: function() {
    return ["assignCarrier", "respondOrComplete"][this.state.step];
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(Blocker, { modalView: this.possibleEmailForwarder(this.props.email) || this.possibleMarkComplete(this.props.email) }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__header" }, /* @__PURE__ */ React.createElement(
      IndexerHeader,
      {
        email: this.props.email,
        carrier: this.props.email.carrier,
        canSetCarrier: this.state.step === 1,
        setCarrier: this.startSetCarrier,
        canMarkComplete: true,
        markComplete: this.startMarkingComplete,
        actions: [["Forward Email", this.forwardEmail]]
      }
    )), /* @__PURE__ */ React.createElement(NoDocumentsProgressBar, { stepNumber: this.state.step }), /* @__PURE__ */ React.createElement("div", { className: "reply-view__main-body row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, this.carrierSetterOrReply(), "\xA0"), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, this.emailChainViewer()), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
      PresenceList,
      {
        location: this.props.location,
        emailId: this.props.email.id
      }
    )))));
  },
  emailChainViewer: function() {
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        model: this.documentModel,
        additionalComponents: this.additionalBrowserComponents(),
        location: this.props.location
      }
    );
  },
  documentFromEmail: function(emailMessage) {
    return ApiService.addErrorHandler(
      $.post(
        "/api/email_messages/" + emailMessage.id + "/create_document"
      )
    );
  },
  documentFromEmailCallback: function(data) {
    const newLocation = this.props.location.query.onDone || "/dashboard";
    this.history.pushState(
      null,
      "/index-document-batches/" + data.document_batch.id,
      { onDone: newLocation }
    );
  },
  possibleMessageBrowserComponent: function() {
    const email = this.props.email;
    const emails = this.props.email && _.sortBy(
      email.parent_emails.concat(email.replies).concat(email),
      "created_at"
    ).reverse();
    if (emails.length > 0) {
      return {
        label: "Message",
        component: EmailHelper.emailMessages(
          emails,
          this.documentFromEmail,
          this.documentFromEmailCallback
        )
      };
    }
  },
  additionalBrowserComponents: function() {
    return [
      this.possibleMessageBrowserComponent()
    ];
  },
  documentModel: function() {
    return new GroupedDocumentBrowserModel(
      new DocumentBatchGroupCreator(
        documentBatches,
        function(doc) {
          return doc.carrier_invoice_id === invoiceID;
        }
      )
    );
  },
  startSetCarrier: function() {
    this.setState({ step: 0, forcedStep: true });
  },
  carrierSetterComplete: function(e) {
    this.props.carrierSetter.onSetCarrier(e).then(function(result) {
      this.setState({ step: 1 });
    }.bind(this));
  },
  possibleProcessOriginal: function() {
    if (this.props.documentGroup) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "/app/index-document-batches/" + this.props.documentGroup.document_batch_id + "?group_id=" + this.props.documentGroup.id,
          className: "button button--confirmation"
        },
        "Process Original Documents"
      );
    }
  },
  carrierSetterOrReply: function() {
    if (this.state.step === 0) {
      return /* @__PURE__ */ React.createElement(
        CarrierSetter,
        {
          isReceivablesEmail: this.isReceivablesEmail(this.props.email),
          onSetCarrier: this.carrierSetterComplete,
          carrier: this.props.carrier || {},
          isSingleCarrier: this.props.email.single_carrier
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, "No documents were found on this email. You can either reply to this message or ignore this entry."), this.possibleProcessOriginal(), /* @__PURE__ */ React.createElement("h3", null, "Send a Reply"), /* @__PURE__ */ React.createElement(
        ExceptionSender,
        {
          onComplete: this.props.returningMethods.onComplete,
          sendEmail: this.props.returningMethods.sendEmail,
          defaultEmail: {
            body: this.quotedBody(this.props.email, this.exceptionsSignature()),
            subject: "Re: " + this.props.email.subject
          },
          markParentComplete: true,
          emailMessageId: this.props.email.id,
          parent: this.props.email
        }
      ));
    }
  },
  exceptionsSignature() {
    return Auth.getCurrentUser().settings["exceptions_signature"] || "";
  },
  quotedBody: function(email, signature) {
    var whiteSpace = "\n\n";
    var prefix = "\n\nat " + moment(email.created_at).format("LLL") + email.sender_address + " wrote:\n";
    return whiteSpace + signature + prefix + _.map(_.str.lines(email.text_body), function(line) {
      return "> " + line;
    }).join("\n");
  },
  cancelMarkingComplete: function() {
    this.setState({ markingComplete: false });
  },
  startMarkingComplete: function(email) {
    this.setState({ markingComplete: true });
  },
  doneMarkingComplete: function() {
    if (this.props.location) {
      var location = this.props.location.query.onDone || "/dashboard";
    } else {
      var location = "/dashboard";
    }
    ToDashboardWithFilters(this.props.location, this.history);
  },
  possibleMarkComplete: function(email) {
    if (this.state.markingComplete) {
      return /* @__PURE__ */ React.createElement(MarkEmailCompleteView, { email, onCancel: this.cancelMarkingComplete, onMarkCompleteFinished: this.doneMarkingComplete });
    }
  },
  isReceivablesEmail(email) {
    function isReceivablesLabel(label) {
      return label.name == "Receivables";
    }
    return email.labels.some(isReceivablesLabel);
  }
});
export { EmailWithoutDocuments };
